import { useStore as useZustandStore } from 'zustand'
import { store } from '../store'

/**
 * Hook to access the Zustand store in React components
 * @param {Function} selector - Function to select state from the store
 * @returns {any} Selected state from the store
 */
export function useStore(selector) {
  return useZustandStore(store, selector)
} 